import { render, staticRenderFns } from "./CunsultasAlunosModal.vue?vue&type=template&id=07e53de0&scoped=true"
import script from "./CunsultasAlunosModal.vue?vue&type=script&lang=js"
export * from "./CunsultasAlunosModal.vue?vue&type=script&lang=js"
import style0 from "./CunsultasAlunosModal.vue?vue&type=style&index=0&id=07e53de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e53de0",
  null
  
)

export default component.exports